import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const WarningIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g id="warning" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path
                    d="M13.7557911,3.21895043 L22.3867068,19.0422957 C22.9156322,20.0119924 22.5583166,21.2268657 21.5886199,21.7557911 C21.2948427,21.9160333 20.9655536,22 20.6309156,22 L3.36908438,22 C2.26451488,22 1.36908438,21.1045695 1.36908438,20 C1.36908438,19.665362 1.45305112,19.3360729 1.61329323,19.0422957 L10.2442089,3.21895043 C10.7731343,2.24925376 11.9880076,1.89193809 12.9577043,2.42086355 C13.2948373,2.6047543 13.5719004,2.8818174 13.7557911,3.21895043 Z"
                    id="Triangle"
                    fill="#FF991F"
                ></path>
                <path
                    d="M11.3071161,15.2738854 L11.0973783,9 L12.9026217,9 L12.6928839,15.2738854 L11.3071161,15.2738854 Z M11,18 L11,16.3184713 L13,16.3184713 L13,18 L11,18 Z"
                    id="!"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                ></path>
            </g>
        </SvgIcon>
    );
};
